import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { pronunciationKeys } from './pronunciationKeys';
import { useTranslation } from 'react-i18next';

export interface IDeletePronunciationParams {
  id: number;
}

export const deletePronunciation = async (
  params: IDeletePronunciationParams
): Promise<void> => {
  const { id } = params;
  await EXPRESS_API.delete(`/customer-phonetics/${id}`);
};

export const useDeletePronunciationMutation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(deletePronunciation, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(pronunciationKeys.all());
      onSuccess?.();
      successToast({
        title: t(`Pronunciation has been successfully deleted!`),
      });
    },
    onError: error =>
      showError(
        error || t`An error occurred while trying to delete the pronunciation.`
      ),
  });
};
